<template>
  <div class="header module-text-header" :class="['ad' + styleType, {'square-header-wrap': radiusType === 'square' && buttonUrl}]">
    <div :class="['module-text-header-left', {'need-text-left': radiusType === 'square' && buttonUrl}]">
      <div class="title text-overflow-ellipsis-2">
        <i v-if="emphasis === '1'" class="dot-box" :style="{ backgroundColor: dotColor }" /> {{ title }}
      </div>
      <div v-if="describe" class="describe text-overflow-ellipsis-4">
        {{ describe }}
      </div>
    </div>
    <DiffLinkLabel v-if="buttonName && radiusType === 'square' && buttonUrl" :url="buttonUrl" :target="linkTarget">
      <div class="module-text-header-right">
        {{ buttonName }}
        <span class="iconfont icona-GreyArrow" />
      </div>
    </DiffLinkLabel>
  </div>
</template>

<script>
/**
 *  模块头部
 */
import mixin from './mixin';
import DiffLinkLabel from '../DiffLinkLabel/web.vue'
import linkTargetMixin from '../CommonMixin/linkTarget'

export default {
  components: {
    DiffLinkLabel,
  },
  mixins: [mixin, linkTargetMixin],
}
</script>
<style lang="scss" scoped>
.dot-box {
  display: inline-block;
  width: 18px;
  height: 14px;
  background-color: #000;
  border-radius: 7px;
  margin-right: 4px;
  margin-top: -12px;
  vertical-align: middle;
}

@media (max-width: 768px) {
  .ad11,
  .ad74,
  .ad73 {
    &.module-text-header {
      margin-bottom: 5.333vw;

      .describe {
        line-height: 8.533vw;
      }
    }

    .title {
      font-size: 8.533vw;
      text-align: left;
      line-height: 10.667vw;
      margin-bottom: 10vw;
    }

    .describe {
      font-size: 4.267vw;
    }

    .dot-box {
      display: none;
    }
  }
}
</style>
